<template>
  <div class="footer">
    <span>Copyright &copy; <a v-if="isshow_icp" class="icp-link" href="http://beian.miit.gov.cn" target="_blank">{{isshow_icp}}</a> {{title}} All Rights Reserved.</span>
    <span></span>
  </div>
</template>

<script>
import getWebsiteAjax from '@/util/getWebsiteAjax'
export default {
  name: 'Footer',
  data() {
    return {
    	isshow_icp:false
    }
  },
  async created() {
  	const data = await getWebsiteAjax()
  	this.isshow_icp = data.isshow_icp
  },
  computed: {
    title() {
      return this.$store.state.title
    },
    // isshow_icp() {
    //   return this.$store.state.isshow_icp
    // }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fff;
  background-color: #909090;
  font-size: 14px;
  z-index: 2;
  span {
    margin: 0 9px;
  }
}
.icp-link {
  color: rgba($color: #fff, $alpha: .4);
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue